import styled from 'styled-components';
import Modal from '../CommonComponents/Modal';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { PageWrapper } from '../CommonComponents/PageWrapper/PageWrapper';

interface HeaderProps {
  isEmbeddedMobile: boolean;
}

export const Header = styled.header<HeaderProps>(({ theme, isEmbeddedMobile }) => ({
  display: 'none',

  [`@media only screen and (min-width: ${isEmbeddedMobile ? theme.breakpoints[0] : '0px'})`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: '1000px',
    boxSizing: 'border-box',
  },
}));

export const Card = styled.div`
  padding: 24px;
  border: 1px solid #e3e1e1;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(184, 184, 184, 0.08);
  background: #ffffff;
  margin: 6px 0;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const StyledModal = styled(Modal)`
  &__content {
    padding: 50px;
    box-sizing: border-box;
    width: 670px;
  }
`;

export const RightMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-gap: 8px;
`;

interface TabsWrapperProps {
  isEmbeddedMobile: boolean;
}

export const TabsWrapper = styled(Box)<TabsWrapperProps>(({ theme, isEmbeddedMobile }) => ({
  [`@media only screen and (max-width: ${isEmbeddedMobile ? theme.breakpoints[0] : '0px'})`]: {
    paddingBottom: theme.space['4'],
  },

  '& ul': {
    marginBottom: theme.space['24'],

    [`@media only screen and (max-width: ${isEmbeddedMobile ? theme.breakpoints[0] : '0px'})`]: {
      overflow: 'scroll',
      width: 'auto',
      whiteSpace: 'nowrap',
    },
  },
}));

export const DesktopPageWrapper = styled(PageWrapper)(({ theme }) => ({
  display: 'grid',
  gap: theme.space[8],
  gridTemplateColumns: 'repeat(2, 1fr)',
  margin: 0,
  padding: 0,
}));

export const MobilePageWrapper = styled(PageWrapper).attrs({ isEmbeddedMobile: true })({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  margin: 0,
  padding: 0,
});
